import React, { Component } from "react";

const CURRENT_YEAR = new Date().getFullYear();
const COMPANY_NAME = "Explore TouristHub Holidays LLP";

class Footer extends Component {
    render() {
        return (
            <footer className="admin-footer sticky-footer">
                <div className="admin-footer__inner">
                    <div className="admin-footer__brand">
                        <i
                            className="fa-solid fa-compass admin-footer__brand-icon"
                            aria-hidden="true"
                        />
                        <div className="admin-footer__brand-text">
                            <span className="admin-footer__brand-name">{COMPANY_NAME}</span>
                            <span className="admin-footer__brand-tag">Admin Portal</span>
                        </div>
                    </div>
                    <div className="admin-footer__meta copyright">
                        <span>
                            &copy; {CURRENT_YEAR} {COMPANY_NAME}. All rights reserved.
                        </span>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;
